import { ArrowUpRight } from "lucide-react";
import { CONTACT } from "../data";
import { useQuote } from "../context/QuoteContext";
import { Reveal } from "./Reveal";

export const CtaBand = () => {
  const { openQuote } = useQuote();
  return (
    <section className="bg-background py-20 sm:py-24" data-testid="cta-band">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 text-center">
        <Reveal>
          <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-ink leading-tight">
            Jouw dak, gevel of buitenruimte laten reinigen?
          </h2>
        </Reveal>
        <Reveal delay={0.08}>
          <p className="mt-4 text-muted-foreground">
            Vraag binnen enkele minuten vrijblijvend een offerte aan. Stuur
            enkele foto's mee, zodat we de situatie alvast kunnen beoordelen en
            gericht advies kunnen geven.
          </p>
        </Reveal>
        <Reveal delay={0.16}>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={() => openQuote()}
              data-testid="ctaband-button"
              className="group inline-flex items-center gap-2 rounded-full bg-teal px-7 py-4 font-semibold text-white transition-transform duration-300 hover:-translate-y-0.5"
            >
              Gratis offerte aanvragen
              <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </button>
            <a
              href={CONTACT.phoneHref}
              className="text-sm font-semibold text-ink/70 transition-colors hover:text-teal"
            >
              Of bel ons voor persoonlijk advies: {CONTACT.phone}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default CtaBand;
